import Header from "../components/Header";
import Footer from "../components/Footer";
import ServicesHeroBanner from "../components/ServicesHeroBanner";
import MultpleCard from "../components/Multple-card";
import ServicesProcess from "../components/ServicesProcess";
import Choose from "../components/Choose";
import ContactForm from "../components/contact-form";
import Blog from "../components/Blog";

import servicesHeaderImage from "../images/comp/services-header-image-1.webp";
import diverseImage from "../images/comp/diverse-friends-using-digital-devices 3.webp";
import researchIcon from "../images/research-icon.png";
import planningIcon from "../images/Planning.png";
import designIcon from "../images/Design.png";
import developmentIcon from "../images/development.png";
import qualityIcon from "../images/Quality.png";
import ux_icon from "../images/ux_icon.png";
import testingIcon from "../images/Testing.png";

const MobileAppDevelopment = () => {
  const heroBannerData = {
    subtitle: "Mobile App Development",
    title: "Apps That Engage. Apps That Perform.",
    description:
      "At Hope Web Solutions, we craft high-performance mobile applications that drive user engagement and business growth. From idea validation to post-launch support, our expert team ensures seamless app development tailored to your specific needs—delivering scalable, secure, and intuitive mobile experiences.",
    buttonText: "Contact now",
    buttonLink: "/contact",
    img: servicesHeaderImage,
  };
  const cardsData = [
    {
      title: "iOS App Development",
      description:
        "Creating robust, scalable applications for iPhones and iPads using Swift and Objective-C.",
      icon: researchIcon,
    },
    {
      title: "Android App Development",
      description:
        "Designing reliable and optimized Android apps tailored to a wide range of devices and user needs.",
      icon: planningIcon,
    },
    {
      title: "Cross-Platform Development",
      description:
        "Building cost-effective apps using Flutter, React Native, and other frameworks that work seamlessly on both iOS and Android.",
      icon: designIcon,
    },
    {
      title: "Mobile UI/UX Design",
      description:
        "Designing intuitive interfaces and engaging experiences that enhance user satisfaction and retention",
      icon: ux_icon,
    },
    {
      title: "QApp Testing & QA",
      description:
        "Ensuring your app is error-free with comprehensive manual and automated testing across devices.",
      icon: testingIcon,
    },

    {
      title: "App Store Deployment",
      description:
        "Handling the submission process for Apple App Store and Google Play Store with complete compliance and support.",
      icon: developmentIcon,
    },
  ];

  const processData = [
    {
      title: "Requirement Analysis",
      description:
        "Understanding your business needs, target audience, and goals to define the website’s scope.",
      icon: researchIcon,
    },
    {
      title: "Wireframing & Planning",
      description:
        "Laying out the website structure, sitemap, and user flow for a clear development path.",
      icon: designIcon,
    },
    {
      title: "Design Phase",
      description:
        "Creating visually engaging and brand-aligned UI designs for web interfaces.",
      icon: developmentIcon,
    },
    {
      title: "Development Phase",
      description:
        "Coding the front-end and back-end of the website using best practices and modern technologies.",
      icon: testingIcon,
    },
    {
      title: "Testing & QA",
      description:
        "Performing rigorous testing for performance, security, and cross-browser compatibility.",
      icon: qualityIcon,
    },
    {
      title: "Launch & Support",
      description:
        "Deploying the website and offering ongoing maintenance, updates, and performance optimization.",
      icon: planningIcon,
    },
  ];

  const chooseData = {
    title: "Why Choose Hope Web Solutions?",
    image: diverseImage,
    imageAlt: "Team",
    items: [
      {
        label: "Planning",
        text: "Hope Web Solutions is a leading Web and Mobile App Development company, delivering cutting-edge digital solutions.",
      },
      {
        label: "Our Mission",
        text: "Our mission is to empower businesses with exceptional digital solutions that drive growth, enhance user experience.",
      },
      {
        label: "Our Vision",
        text: "Our vision is to be a global leader in web and mobile app development, recognized for our innovation, quality, and customer satisfaction.",
      },
    ],
    buttonText: "Contact now",
    buttonLink: "/contact",
  };

  return (
    <div>
      <Header />
      <ServicesHeroBanner {...heroBannerData} />
      <section className="planning-section-services">
        <div className="container">
          <div className="process-grid mt-0">
            {/* 👉 Cards Loop */}
            {cardsData.map((item, index) => (
              <MultpleCard
                key={index}
                title={item.title}
                description={item.description}
                icon={item.icon}
              />
            ))}
          </div>
        </div>
      </section>
      <ServicesProcess
        title="Web Development Process"
        subtitle="Our structured development process ensures high-quality, secure, and scalable web solutions delivered on time."
        processData={processData}
      />
      <Choose {...chooseData} />
      <ContactForm />
      <Blog />
      <Footer />
    </div>
  );
};

export default MobileAppDevelopment;
